import React from 'react';

import { ButtonProps } from '@magoosh/lib/button/base';
import colors from '@magoosh/lib/styles/colors.module.scss';

import style from './style.module.scss';

const isSmallSize = (size: ButtonProps['size']) =>
  ['xs', 'xsmall', 'sm', 'small'].includes(size);

export const GradientButton = (props: ButtonProps) => {
  const isSmall = isSmallSize(props.size);
  const padding = isSmall ? '0px 10px' : '8px 15px';

  if (props.disabled) {
    return (
      <div className="d-flex flex-none">
        <div
          className="align-items-center d-flex flex-none gap-xxs"
          style={{
            background: '#fff',
            border: `${isSmall ? '0.5px' : '1px'} solid ${colors.grayLighter}`,
            borderRadius: 24,
            color: colors.grayLight,
            padding
          }}
        >
          {props.children}
        </div>
      </div>
    );
  }

  return (
    <div style={{ position: 'relative', zIndex: 1 }}>
      <div
        className={`align-items-center d-flex flex-none gap-xxs ${style.gradientButton} ${isSmall ? style.gradientButtonSmall : ''}`}
        style={{ padding }}
      >
        <div
          onClick={props.onClick}
          style={{
            background: '-webkit-linear-gradient(0deg, #0577E9, #5227F8)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent'
          }}
        >
          {props.children}
        </div>
      </div>
    </div>
  );
};

export const GradientFilledButton = (props: ButtonProps) => {
  const padding = isSmallSize(props.size) ? '4px 10px' : '8px 15px';

  if (props.disabled) {
    return (
      <div className="d-flex flex-none">
        <div
          className="align-items-center d-flex flex-none gap-xxs"
          style={{
            background: colors.grayLighter,
            borderRadius: 24,
            color: colors.grayLight,
            padding
          }}
        >
          {props.children}
        </div>
      </div>
    );
  } else {
    return (
      <div className="d-flex flex-none">
        <div
          className="align-items-center d-flex flex-none gap-xxs"
          onClick={props.onClick}
          style={{
            background: 'linear-gradient(90deg, #0577E9, #5227F8)',
            borderRadius: 24,
            boxShadow: '0px 2px 2px -1px #0000000D, 0px 5px 5px -2.5px #0000000D, 0px 0px 0px 1px #0000001A',
            color: '#fff',
            cursor: 'pointer',
            padding
          }}
        >
          {props.children}
        </div>
      </div>
    );
  }
};
